import usUrl from '../../assets/coverage/us.geojson';
import canadaUrl from '../../assets/coverage/canada.geojson';
import newZealandUrl from '../../assets/coverage/new_zealand.geojson';
import ukEnglandUrl from '../../assets/coverage/uk_england.geojson';
import netherlandsUrl from '../../assets/coverage/netherlands.geojson';
import switzerlandUrl from '../../assets/coverage/switzerland.geojson';
import norwayUrl from '../../assets/coverage/norway.geojson';
import portugalUrl from '../../assets/coverage/portugal.geojson';
import scotlandUrl from '../../assets/coverage/scotland.geojson';
import walesUrl from '../../assets/coverage/wales.geojson';
import franceUrl from '../../assets/coverage/france.geojson';
import austriaUrl from '../../assets/coverage/austria.geojson';
import uruguayUrl from '../../assets/coverage/uruguay.geojson';
export const COVERAGE_REGIONS = [
    { id: 'us', label: 'United States (USGS 3DEP)', url: usUrl },
    { id: 'canada', label: 'Canada (NRCan HRDEM)', url: canadaUrl },
    { id: 'new_zealand', label: 'New Zealand (LINZ)', url: newZealandUrl },
    { id: 'uk_england', label: 'United Kingdom — England (Environment Agency)', url: ukEnglandUrl },
    { id: 'netherlands', label: 'Netherlands (AHN)', url: netherlandsUrl },
    { id: 'switzerland', label: 'Switzerland (swisstopo swissALTI3D)', url: switzerlandUrl },
    { id: 'norway', label: 'Norway (Kartverket)', url: norwayUrl },
    { id: 'portugal', label: 'Portugal (DGT)', url: portugalUrl },
    { id: 'scotland', label: 'Scotland (Scottish Remote Sensing Portal)', url: scotlandUrl },
    { id: 'wales', label: 'Wales (DataMapWales)', url: walesUrl },
    { id: 'france', label: 'France (IGN RGE ALTI / LiDAR HD)', url: franceUrl },
    { id: 'austria', label: 'Austria (BEV national ALS DTM)', url: austriaUrl },
    { id: 'uruguay', label: 'Uruguay (IDEuy national 2.5m MDT)', url: uruguayUrl },
];
